import { defineAsyncComponent } from 'vue'
export default {
  "lilly-microsite": defineAsyncComponent(() => import("/home/bun/app/layouts/LillyMicrosite.vue")),
  "lilly-microsite2": defineAsyncComponent(() => import("/home/bun/app/layouts/LillyMicrosite2.vue")),
  "logicbomb-media": defineAsyncComponent(() => import("/home/bun/app/layouts/LogicbombMedia.vue")),
  "voix-marketing": defineAsyncComponent(() => import("/home/bun/app/layouts/VoixMarketing.vue"))
}